import {stringify, parse} from 'query-string';

export function userException( message ) {
    this.message = message;
    this.name = "UserException";
    this.log = true;
    this.loglevel = 'error';
}

export function escapeHtml( string ) {
    var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': '&quot;',
        "'": '&#39;',
        "/": '&#x2F;'
    };
    return String( string ).replace( /[&<>"'\/]/g, function ( s ) {
        return entityMap[s];
    } );
}

export function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export const sortNumberDesc = (a, b) => {

    if(parseInt(a) < parseInt(b)){
        return 1;
    }
    if(parseInt(a) === parseInt(b)){
        return 0;
    }
    return -1;
};



export const buildQuerySegmentFromObject = (object, search) => {
    let query = '';
    for(let segment in object){
        query += '&' + segment + '=' + object[segment];
    }
    if (typeof search !== 'string') {
        throw Error('Specify a string search argument.')
    }
    if(search.length > 0){
        query += '&text=' + search
    }
    return query;
};





// WEBPACK FOOTER //
// ./src/helper/utils.js